export default class HotelAddress {
  static fromJSON (json) {
    return new HotelAddress({
      country: json.country,
      countryCode: json.countryCode,
      city: json.city,
      cityCode: json.cityCode,
      zip: json.zip,
      street: json.street,
      stateCode: json.stateCode
    })
  }

  constructor ({ country, countryCode, city, cityCode, zip, street, stateCode }) {
    this.country = country
    this.countryCode = countryCode
    this.city = city
    this.cityCode = cityCode
    this.zip = zip
    this.street = street
    this.stateCode = stateCode
  }

  format () {
    return `${this.street}, ${this.city}, ${this.zip ? (this.zip + ',') : ''} ${this.country}`
  }
}
